import { usePageMetadata } from "../../Core/Content/Hooks";
import { useEffect, useRef, useState } from "react";
import AppService from "../../service/app.service";

export const useAboutHook = () => {
  const [aboutPageData, setAboutPageData] = useState(null);
  usePageMetadata(aboutPageData, "SouledOut | About");
  const appService = new AppService();
  const [error, setError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchedRef = useRef(false);
  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;
    (async () => {
      try {
        const result = await appService.getPage("about");
        setAboutPageData(result.data);
        setError(result.error);
        setIsLoading(result.isLoading);
      } catch (e: any) {
        setError(e);
        setIsLoading(false);
      }
    })();
  }, []);

  return {
    aboutPageData,
    error,
    isLoading,
  };
};
